(function (app) {
    'use strict';

    app.factory('formServices', formServices);

    /*@ngInject*/
    function formServices(queryservice, _){
        return  {
            getOptions:getOptions,
            getOptionsFrom:getOptionsFrom,
            unwrapOptions:unwrapOptions,
            findOptionNamePerId:findOptionNamePerId,
            findOptionNamePerCODE :findOptionNamePerCODE
        };

        function getOptions(cbIdList, passthrough, args) {
            //if(cbIdList){
                var fctArgsJson = args || {};
                fctArgsJson.cbIdList = cbIdList;
                //if(passthrough){fctArgsJson.passthrough =  angular.extend({}, passthrough, fctArgsJson.passthrough);
                fctArgsJson.passthrough = passthrough;
                //}
                var fctName= "obtUiHelper.getComboxBoxUpdate";
                return queryservice.callServer(fctName,fctArgsJson).then(unwrapOptions);
            //}
        }

        function findOptionNamePerId(idToSearch, options, keyName, fieldName){
            if(!keyName){ keyName = 'KEY'}
            if(!fieldName){fieldName = 'VALUE';}

            var fieldsToSearch = {};
            fieldsToSearch[keyName] = idToSearch;
            return _.result(_.findWhere(options, fieldsToSearch), fieldName);
        }
        function findOptionNamePerCODE(code,options){
         var keyName = 'CODE'
         var fieldName = 'KEY';

            var fieldsToSearch = {};
            fieldsToSearch[keyName] = code;
            return _.result(_.findWhere(options, fieldsToSearch), fieldName);
        }

        function unwrapOptions(response){
            var options = {};

            if (response && response.updateComboBox) {
                _.each(response.updateComboBox, function (item) {
                    if(item.COMBOVALUE instanceof Array){
                        item.COMBOVALUE.map(function(item){
                            var parsedString =  parseInt(item.KEY, 10);
                            if( ! isNaN(parsedString)){
                                item.KEY = parsedString ;
                            }
                            return item;
                        });
                    }
                    options[item.NAME] = item.COMBOVALUE;

                    //setDefault
                    _.each(item.COMBOVALUE, function findDefaultID(subItem){
                        if(subItem.ISDEFAULT){
                            options[item.NAME + '_default'] = subItem.KEY;
                        }
                    });

                });
            }
            return options;
        }

        function getOptionsFrom(data, name ){
            return _.result(_.find(data, {NAME:name}), 'COMBOVALUE');
        }
    }
})(angular.module('app.data'));



/*****************
 ** WEBPACK FOOTER
 ** ./app/data/form.services.js
 ** module id = 166
 ** module chunks = 0
 **/